import Route from '@ember/routing/route';
import { Changeset } from 'ember-changeset';
import targetValidations from 'scaleflow/validators/target';
import goalValidations from 'scaleflow/validators/goal';
import { service } from '@ember/service';
import { get } from '@ember/object';

export default class BusinessGoalsGoalEditRoute extends Route {
  @service store;

  beforeModel() {
    return Promise.all([
      this.store.findAll('person'),
      this.store.findAll('metric'),
    ]);
  }

  model() {
    return this.modelFor('business.goals.goal');
  }

  goalValidator({ key, newValue, oldValue, changes, content }) {
    let validator = get(goalValidations, key);
    if (typeof validator === 'function') {
      return validator(newValue, oldValue, changes, content);
    }
  }

  targetValidator({ key, newValue, oldValue, changes, content }) {
    let validator = get(targetValidations, key);
    if (typeof validator === 'function') {
      return validator(newValue, oldValue, changes, content);
    }
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    const goalChangeset = Changeset(model.changeset_object, this.goalValidator);
    const targetChangesetFactory = (targetModel = undefined) => {
      const target = targetModel ?? this.store.createRecord('target', {});
      return Changeset(target, this.targetValidator);
    };

    controller.set('goalChangeset', goalChangeset);
    controller.set(
      'selectedGoals',
      model.parent?.content ? [model.parent.content] : [],
    );
    controller.set('selectedMetrics', model.metrics);
    controller.set('targetChangesetFactory', targetChangesetFactory);

    const targets = model.targets.content ?? [];
    const targetChangesets = targets.map((target) => {
      return Changeset(target, this.targetValidator);
    });
    controller.set('targetChangesets', targetChangesets);
  }

  resetForm(controller) {
    controller.set('activeStep', 0);
    controller.set('targetChangesets', []);
    controller.set('selectedGoals', []);
    controller.set('selectedMetrics', []);
    controller.set('goalSearch', '');
    controller.set('metricSearch', '');
    controller.set('goalChangeset', null);
    controller.set('showDeleteModal', false);
    controller.set('selectedGoal', null);
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.resetForm(controller);
    }
  }
}
